import { getLiveGrips } from "../api";

export async function resolveGripFromBC({ productId, variantId, serviceType }) {
  const wantType = String(serviceType || "Regular").toLowerCase();

  try {
    const grips = await getLiveGrips();

    let found = grips.find(
      (g) =>
        String(g.bc_product_id) === String(productId) &&
        String(g.bc_variant_id) === String(variantId) &&
        String(g.type).toLowerCase() === wantType
    );

    if (!found) {
      found = grips.find(
        (g) =>
          String(g.bc_product_id) === String(productId) &&
          String(g.type).toLowerCase() === wantType
      );
    }

    if (!found) {
      const anyWithProduct = grips.find(
        (g) => String(g.bc_product_id) === String(productId)
      );
      if (anyWithProduct) {
        found = grips.find(
          (g) =>
            g.name === anyWithProduct.name &&
            String(g.type).toLowerCase() === wantType
        );
      }
    }

    if (!found) return null;

    return {
      gripId: found.grip_id,
      gripName: found.name,
      gripType: found.type,
      price: found.basePrice || found.cost_per_unit,
      brand: found.brand,
      sku: found.sku,
    };
  } catch (error) {
    console.error("[gripResolver] Error fetching grips:", error);
    return null;
  }
}
